import useSWR from 'swr'
import { GetSessionID } from '../Utility/SessionUtility';

/**
 * 本登録情報の型
 */
export interface WorkRegistrationType {
    artwork_id: string,
    country_name: string,
    mailaddress: string,
    group_flg: string,
    group_num: number,
    interest_work: string,
    pdf_file_name: string,
    country_name1: string,
    poster1: string,
    birthday1: string,
    educational_institution1: string,
    educational_institution_country_name1: string,
}

/**
 * 本登録情報Hook
 * 対象年度の本登録情報を取得する
 * @param year 対象年度
 */
export function useWorkRegistration(year?:string) {

    const fetchAddress = `/competition/api/management/registration?targetyear=${year}&sessionId=${GetSessionID()}`;

    const fetcher = () => fetch(fetchAddress).then(res => res.json());

    const {data, error, isLoading, mutate} = useSWR(`WorkRegistration${year}`, fetcher, {revalidateOnFocus:false, revalidateOnReconnect:false});

    return{
        /**
         * 本登録情報配列
         */
        workRegistration: data,

        /**
         * ロード中フラグ
         */
        isLoading,

        /**
         * エラーフラグ
         */
        isError: error,

        /**
         * 再取得関数
         */
        mutate,
    }
}